rdefine('app/formular/components/DummyForm',['backbone'],function(Backbone) {
    return Backbone.Ribs.View.extend({
        bindings:{
            "span":{
                "text":"model.title"
            },
            "div":{
                text:"model.base.name"
            },
            "i": {
                text:'model.order'
            }
        },
        initialize:function() {
            this.$el.addClass("form-placeholder");
            if(this.model.get("placeholder")) {
                this.$el.addClass("active");
            }
            this.$el.html("<span></span>-<div></div><i></i>");
           // this.$el.html(JSON.stringify(this.model.attributes));
        }
    });
});